import React, { useState, useRef, useEffect } from 'react';
import { useXAgent } from '@ant-design/x';
import { cloneDeep } from 'lodash';
import { handleHistoryRecord, handleSessionList, checkBusiness, outLogin, handleDeerFlowHistory, handleGetSkillDetail } from '@/api/grt/ai';
import { v4 as uuidv4 } from 'uuid';
import { GrtAiMarkdown } from '../components/Markdown/GrtAiMarkdown';
import { baseAiURL } from '../httpService/API';
import ToastUtils from '../utils/ToastUtils';
import { removeTagsAndContent } from '../utils';
import { Display } from '../components/Display/Display';
import { handleSkillGroup, getSkillList } from '@/utils/Page';
import { dateMap, defaultSkill, contentType, fileStatusDic, parseStatusDic } from '@/utils/Page/constant';
import FileSearchDisplay from '@/components/FileSearch';
import { FlowMsg } from '../utils/Page/flowData';
import { formatHistoryData } from './hooks/DeerFlow/useDeerFlow';
import MyIcon from '@/components/MyIcon';

import useDeerFlow from './hooks/DeerFlow/useDeerFlow';
import useAippt from './hooks/useAippt';
import './usual.scss';

import CourseRecommend from './pageComponents/CourseRecommend';
import MultimodalLearning from './pageComponents/MultimodalLearning';
import MultimodalReference from './Web/PageComponents/MultimodalLearning/MultimodalReference';
import Review from './Web/PageComponents/Review';
import { Tooltip } from 'antd';
import { handleFeedBack, handleMobileFeedBack } from '@/utils/Page/feedback';
import { showMobileFileDetail } from '@/utils/Page/search';
import { removeModal, removeMultimodalModal } from '../utils/Page/modal';
import { Storage } from '../utils/Storage';
import { getUserId } from '../utils/Page';
import ResearchPlanCard from '../components/ResearchPlanCard';
import { third_json_handler } from '@/utils/Page/constant';
import { getMobileHideSkills } from '@/utils/Page';
// 引入TTS事件发射器
import useTTSHandler from '@/pages/hooks/useTTSHandler';
// 引入RtcClient用于检查语音通话状态
import { ConfigFactory } from '@/configTTS';
import usePreQuestion from './hooks/usePreQuestion';
import ImagePreview from '@/pages/Web/Outside/pages/roomTTS/components/ImagePreview'; // 添加这行导入语句
import ChatFiles from './pageComponents/ChatFiles';
import useReferences from './hooks/useReferences';
import composeDataWithQuestion from './hooks/DeerFlow/composeDataWithQuestion';
import routeDeerFlowMessage from './hooks/DeerFlow/routeDeerFlowMessage';
import handleDeerFlowPostMessageCleanup from './hooks/DeerFlow/handleDeerFlowPostMessageCleanup';
import syncDeerFlowSessionPolling from './hooks/DeerFlow/syncDeerFlowSessionPolling';
import syncHistorySessionClickable from './hooks/DeerFlow/syncHistorySessionClickable';
import useAgentFile from './hooks/useAgentFile';
import useUsualSkill from './hooks/useUsualSkill';
import useSkill from './hooks/useSkill';
import useMultimodalReference from './hooks/Multimodal/useMultimodalReference';
import { renderAiMessage } from './hooks/useMessageRenderer';
import References from './pageComponents/References';
import { getFileStatus } from '@/utils/Page';
import UserMessage from './Web/PageComponents/CaseSimulation/UserMessage';
import AiCard from './Web/PageComponents/CaseSimulation/AiCard';
import { Regenerate, Copy, FeedBack } from './pageComponents/OperateButton';
import DotLoading from '@/components/Loading/DotLoading';
// const curMsg = {
//   role: "local",
//   status: "complete",
//   id: myLocalId,
//   message: nextContent,
//   type: grtAi?.curPrompts?.id || "" || "",
// }

export const getuuid = () => {
    return uuidv4();
};
let curMsgId = null;
const useChat = (props) => {
    const preQuestionHook = usePreQuestion();
    const deerFlowHook = useDeerFlow();
    const { references, setReferences, referencesRef } = useReferences();
    const { agentFile, setAgentFile, agentFileRef } = useAgentFile();
    const useUsualSkillHook = useUsualSkill();
    const {
        multimodalReference,
        setMultimodalReference,
        multimodalReferenceRef,
        handleMultimodalLearningRequest,
        handleMultimodalHistoryWithUI,
        isMultimodalHistorySkill,
        createOpenHistoryMultimodalList
    } = useMultimodalReference();
    //尽量不要传入一直在变的参数，会导致数据更新不及时
    const {
        side = 'mobile',
        userId = '',
        agentId = '',
        navigate,
        searchParams,
        grtAiStore,
        skillStore,
        sessionId,
        chatBIRef,
        detailPanelOpen,
        setDetailPanelOpen,
        activeDetailMessageId,
        setActiveDetailMessageId,
        currentAgent
    } = props;

    // 创建唯一的页面实例ID
    useEffect(() => {
        if (!window.chatPageInstanceId) {
            const instanceId = Date.now() + '_' + Math.random().toString(36).substr(2, 9);
            window.chatPageInstanceId = instanceId;
        }
        return () => {
            // 清理页面实例ID（当组件卸载时）
            // 注意：不要在这里删除，因为可能有多个useChat实例
        };
    }, []);
    // const [agentFile, changeAgentFile] = useState([]); //智能体附件列表
    // const agentFileRef = useRef([]);

    // const [skillPreQuestion, setSkillPrequesion] = useState([]); //技能的预设问题
    const isNeedGetSessionListRef = useRef(false); //首次会话时，消息结束需要查询会话列表
    const isHasNewSessionIdRef = useRef(false); //开启新会话时记录下后端的会话id是否生成
    const isInAnswerRef = useRef(false); //回答过程中---用户不可输入
    const [recordLoading, setRecordLoading] = useState(false); //请求历史记录时的loading
    const sessionListRef = useRef(null); //后端返回的会话列表--未处理
    const {
        skillList,
        setSkillList,
        skillListRef,
        curPlugin,
        curpluginRef,
        skillPreQuestion,
        setSkillPrequesion,
        setCurPlugin,
        setCurSkill,
        curSkill,
        curSkillRef
    } = useSkill({ searchParams, side, skillStore });
    // const [skillList, setSkillList] = useState({ apartList: [], unApartList: [] });
    // const skillListRef = useRef([]); //技能列表--未处理
    // const [curPlugin, changePlugin] = useState([]);
    // const curpluginRef = useRef([]);
    const [sessionList, setSessionList] = useState({}); //会话历史列表--整理后
    const [sessionMap, setSessionMap] = useState({}); //会话map---前端显示
    const sessionMapRef = useRef({}); //会话map
    const originMsgMapRef = useRef({}); //后端的原始数据
    const currentSessionMapIdRef = useRef(null); //当前会话map的id
    const currentSessionMapIdList = useRef(null); //当前会话
    const [loading, setLoading] = useState(false); //辅助每个会话的loading，解决回答过程中会出现think和answer标签的问题
    const [content, setContent] = useState('');
    const [userid, setUserid] = useState();
    // const [curSkill, changeCurSkill] = useState(null); //当前的技能
    // const curSkillRef = useRef(null);
    const [hideTTSActions, setHideTTSActions] = useState(true);
    const hideTTSActionsRef = useRef(hideTTSActions);
    const processedMessageIds = useRef(new Set());
    const isNewSessionRef = useRef(true);
    const textBuffer = useRef({});

    const [agent] = useXAgent({
        baseURL: baseAiURL + '/agent/session/chat'
    });
    const [basicAgent] = useXAgent({
        baseURL: baseAiURL + '/agent/basic/chat'
    });
    const [multimodalAgent] = useXAgent({
        baseURL: baseAiURL + '/multimodal/chat'
    });
    const [simulationAgent] = useXAgent({
        baseURL: baseAiURL + '/case_simulation/session/start'
    });
    const latestRoundIdRef = useRef(null);
    const latestTimestampRef = useRef(null);
    // const setAgentFile = (data) => {
    //     changeAgentFile(data);
    //     agentFileRef.current = data;
    // };

    const goLogin = () => {
        let redirect = `${window.location.href}`;
        if (side === 'web') {
            window.location.href = `${origin}/login?redirect=${redirect}`;
        } else {
            window.location.href = `${origin}/mobile/login?redirect=${encodeURIComponent(redirect)}`;
        }
    };
    const checkIsLogin = async (needLogin = true) => {
        const res = await grtAiStore.checkLogin();
        if (res) {
            return true;
        }
        if (needLogin) {
            ToastUtils.showToast('请登录');
            setTimeout(() => {
                goLogin();
            }, 500);
        }

        return false;
    };
    const checkCanUse = async () => {
        let res = await checkBusiness({ agent_id: agentId });
        if (!res || !res.success || !res.data) {
            ToastUtils.showToast(res?.msg || '');
            preQuestionHook.setCanClick(true);
            return false;
        }
        return true;
    };
    const linkToSession = (session_id, params) => {
        let side = props.side || 'mobile';
        if (session_id) {
            navigate(`/${side}/o/${agentId}/chat/${session_id}`, params);
        } else {
            navigate(`/${side}/o/${agentId}/chat`, params);
        }
        removeModal();
    };
    //处理会话Map
    const changeSessionMap = (data, originData) => {
        setSessionMap({
            ...sessionMapRef.current,
            ...data
        });
        sessionMapRef.current = {
            ...sessionMapRef.current,
            ...data
        };
        // originMsgMapRef.current = {
        //     ...originMsgMapRef.current,
        //     ...data
        // };
    };

    const changeOriginMsgMapRef = (data) => {
        originMsgMapRef.current = {
            ...originMsgMapRef.current,
            ...data
        };
    };
    //处理指定某个会话--更新其消息、loading等
    const changeSessionMapItem = (key, data, originData) => {
        if (!key) {
            // 如果没有key，则尝试使用当前会话ID
            key = currentSessionMapIdRef.current;
            if (!key) {
                return false;
            }
        }
        let targetMapItem = {};
        if (sessionMapRef.current[key]) {
            targetMapItem = sessionMapRef.current[key];
        }

        // 把 originData/question 与 planButtonsDisabled 的逻辑抽离到工具函数
        let dataWithQuestion = composeDataWithQuestion(originData, data, deerFlowHook);

        let newItem = {
            ...targetMapItem,
            ...dataWithQuestion
        };

        changeSessionMap({
            [key]: newItem
        });
        if (originData) {
            const newMessages = cloneDeep(originData);
            changeOriginMsgMapRef({
                [key]: {
                    ...originMsgMapRef.current[key], // 🔥 保留现有状态（如status）
                    messages: newMessages
                }
            });
        }
    };

    // 使用 AIPPT hook
    const aipptHook = useAippt(changeSessionMapItem);

    //切换工具
    const changeTool = () => {
        // changeSession({});
        closeMultimodalPanel(true); // 切换会话/工具时清空引用
        setCurSkill({});
    };
    const getSkillDetail = async (skill_id) => {
        let res = await handleGetSkillDetail(skill_id);
        if (res && res.data) {
            return res.data;
        }
        return null;
    };
    //点击会话列表时，切换会话
    const changeSession = async (session) => {
        let temSkill = skillListRef.current.find((ele) => {
            return String(ele.ability_id) === String(session.skill_id);
        });
        if (!temSkill) {
            let skillDetail = await getSkillDetail(session?.skill_id);
            temSkill = {
                ability_id: session?.skill_id,
                ...skillDetail
            };
        }
        // 🔥 切换会话时关闭多模态抽屉并清空引用
        closeMultimodalPanel(true);

        if (isSkillNeedLogin(temSkill)) {
            let isLogin = await checkIsLogin();
            if (!isLogin) {
                return false;
            }
        }
        // let isCanUse = await checkCanUse();
        // if (!isCanUse) {
        //     return false;
        // }
        if (!session?.session_id) {
            currentSessionMapIdRef.current = session.session_id;
            return false;
        }
        if (currentSessionMapIdRef.current === session.session_id) {
            return false;
        }
        // 新增：切换会话前停止之前会话的轮询和DeerFlow请求
        const previousSessionId = currentSessionMapIdRef.current;

        if (previousSessionId) {
            // 修复：切换会话时不更新canPause状态，保持原有状态
            deerFlowHook.stopHistoryPolling(previousSessionId, false);

            // 处理DeerFlow会话切换
            const previousSession = currentSessionMapIdList.current;
            if (previousSession) {
                deerFlowHook.handleDeerFlowSessionSwitch(previousSessionId, previousSession, {
                    stopHistoryPolling: deerFlowHook.stopHistoryPolling,
                    changeSessionMapItem,
                    changeOriginMsgMapRef,
                    originMsgMapRef
                });
            }
        }
        setReferences([]);
        clearSendData();
        currentSessionMapIdRef.current = session.session_id;
        currentSessionMapIdList.current = session;

        // 处理DeerFlow会话切换事件
        deerFlowHook.handleDeerFlowSessionSwitch(null, session, {
            stopHistoryPolling: deerFlowHook.stopHistoryPolling,
            changeSessionMapItem,
            changeOriginMsgMapRef,
            originMsgMapRef
        });

        handleGetSessionMessage(session, temSkill);
        linkToSession(session.session_id);
        ConfigFactory(currentSessionMapIdRef.current, currentSessionMapIdRef.current);
    };

    // //设置插件
    // const setCurPlugin = (plugin) => {
    //     changePlugin(plugin);
    //     curpluginRef.current = plugin;
    // };
    //设置技能    //切换技能时重置插件
    // const setCurSkill = (skill) => {
    //     setCurPlugin([]);
    //     changeCurSkill(skill);
    //     curSkillRef.current = skill;
    //     if (skill.left_side === 1 && skill?.pre_question_json) {
    //         setSkillPrequesion(skill?.pre_question_json || []);
    //     } else {
    //         setSkillPrequesion([]);
    //     }
    // };
    const clickGuide = (item) => {
        if (item.link_target === 1) {
            let skill = skillListRef.current.find((ele) => ele.ability_id === item.ability_id);
            if (skill) {
                choseApartSkill(skill);
            }
        } else {
            try {
                let url = new URL(item?.custom_url);
                // window.open(url);
                window.open(url, '_blank', 'noopener,noreferrer');
                return true;
            } catch (err) {
                ToastUtils.showAbnormalToast('无效的链接');
                return false;
            }
        }
    };
    //获取当前会话的消息
    const getCurSessionMsgs = () => {
        let data = originMsgMapRef.current[currentSessionMapIdRef.current]?.messages;
        if (!data) {
            return [];
        }
        return cloneDeep(data);
    };
    const isHasUnFinishedEvaluation = () => {
        let msgs = getCurSessionMsgs();
        console.log(msgs, 'msgs---');
        let len = msgs.length;
        if (len) {
            let ai_evaluation = msgs[len - 1].ai_evaluation;
            if (ai_evaluation && ai_evaluation?.ai_evaluation_result?.status !== 1 && ai_evaluation?.ai_evaluation_result?.status !== 3) {
                return true;
            }
        }
        return false;
    };
    //回答中禁止操作
    const isCanSendMsg = (msg, isPreQuestion = false) => {
        if (isCaseSimulationType(curSkillRef?.current?.ability_id)) {
            console.log('判断上一个流程是否完事');
            return true;
        }
        //输入框内的可以取content字段，重新生成、预设问题需要传入msg
        let message = msg || content;
        if (sessionMap[currentSessionMapIdRef.current] && sessionMap[currentSessionMapIdRef.current]?.loading) {
            ToastUtils.showToast('当前正在生成结果，请稍后操作');
            return false;
        }
        if (isTargetSkillType(curSkillRef?.current?.ability_id, third_json_handler.ai_evaluation)) {
            if (isHasUnFinishedEvaluation()) {
                ToastUtils.showToast('当前流程未完成');
                return false;
            }
        }
        if (!isPreQuestion) {
            let { inUpload, uploadSuccess } = getFileStatus(agentFile);
            if ((!message || message.trim().length === 0) && uploadSuccess.length === 0) {
                return false;
            }

            //如果有附件上传中或者上传失败--不允许发送消息(有一个上传成功的就可以发送)
            if (inUpload.length) {
                return false;
            }
        }
        //无附件--不能发送空白消息

        return true;
    };
    //处理会话相关----------------------------------------------------------------
    //将会话列表处理成前端需要的格式
    const formatSessionList = (data = []) => {
        let sessionIds = [];
        let curSessionObj = {};
        if (!data) {
            return false;
        }
        // If backend returned empty list but we already have a local session list, keep it to avoid UI flash.
        if (Array.isArray(data) && data.length === 0) {
            const hasLocal = sessionListRef && sessionListRef.current && Array.isArray(sessionListRef.current) && sessionListRef.current.length > 0;
            if (hasLocal) {
                console.warn('formatSessionList received empty data; keeping existing sessionListRef to avoid UI flash.');
                return true;
            }
        }
        let arr1 = [],
            arr2 = [],
            arr3 = [];
        data.forEach((item) => {
            sessionIds.push(item.session_id);
            if (item.session_id === currentSessionMapIdRef.current) {
                curSessionObj = item;
            }
            item.checked = false;
            if (item.time_range === '1') {
                arr1.push(item);
            } else if (item.time_range === '2') {
                arr2.push(item);
            } else if (item.time_range === '3') {
                arr3.push(item);
            }
        });
        setSessionList({
            1: {
                icon: 'icon-jintian',
                name: dateMap[1],
                list: arr1
            },
            2: {
                icon: 'icon-zuotian',
                name: dateMap[2],
                list: arr2
            },
            3: {
                icon: 'icon-qitian',
                name: dateMap[3],
                list: arr3
            }
        });

        sessionListRef.current = data;
        // 存在会话id（不在新对话中），但是会话列表中没有找到对应的会话，重置会话
        if (currentSessionMapIdRef.current && !curSessionObj.session_id) {
            console.log(currentSessionMapIdRef.current, 'currentSessionMapIdRef.current');
            console.log(curSessionObj.session_id, 'curSessionObj.session_id');
            resetSession();
        }
    };
    // const initSessionMap = (data) => {
    //     let map = {};
    //     data.forEach((item) => {
    //         map[item.session_id] = {
    //             ...item,
    //             loading: false,
    //             messages: [],
    //             answering: false
    //         };
    //     });
    //     changeSessionMap(map);
    // };
    //获取会话列表
    const getSessionList = async (params) => {
        let data =
            {
                user_id: getUserId(),
                agent_id: agentId
            } || params;
        const res = await handleSessionList(data);
        setUserid(data.user_id);
        let temData = res?.data || [];
        if (side === 'mobile') {
            let mobileHideSkills = getMobileHideSkills();

            temData = temData.filter((ele) => {
                return !mobileHideSkills.some((item) => ele?.handler_json.includes(item));
            });
        }
        if (res && res.success) {
            // If backend returned empty list but we already have local sessions, keep local to avoid flash.
            if (Array.isArray(temData) && temData.length === 0) {
                const hasLocal =
                    sessionListRef && sessionListRef.current && Array.isArray(sessionListRef.current) && sessionListRef.current.length > 0;
                if (hasLocal) {
                    console.warn('getSessionList returned empty; keeping existing sessionListRef to avoid UI flicker.');
                } else {
                    formatSessionList(temData);
                }
            } else {
                formatSessionList(temData);
            }
        }
    };

    //重置会话至初始状态
    const resetSession = (data = {}) => {
        deerFlowHook.setPlanButtonsDisabled(false); // 重置会话时重置按钮状态
        let { skill } = data;

        // 🔥 重置会话时关闭多模态抽屉并清空引用
        closeMultimodalPanel(true);
        currentSessionMapIdRef.current = null;
        isHasNewSessionIdRef.current = false;
        setCurPlugin([]);
        // 使用传入的技能或从技能列表中获取第一个通用技能
        const defaultFromBackend = skillListRef.current && skillListRef.current.length > 0 ? skillListRef.current[0] : defaultSkill;
        setCurSkill(skill || defaultFromBackend);
        clearSendData();
        setReferences([]);
        linkToSession();
    };
    //技能相关--------------------------------------------------------------------------
    //选择隔离技能---开启新对话
    const choseApartSkill = (skill) => {
        resetSession({ skill });
    };
    //聊天相关----------------------------------------------------------------------------
    //开始新的对话--基于当前会话开启的新会话，沿用当前会话的skill
    const startNewMsg = () => {
        if (!skillStore?.skillAvailable) {
            ToastUtils.showToast('该技能暂不可用');
            return;
        }
        deerFlowHook.setPlanButtonsDisabled(false); // 开始新会话时重置按钮状态
        // 优先使用当前技能，否则使用从后端获取的第一个技能
        const defaultFromBackend = skillListRef.current && skillListRef.current.length > 0 ? skillListRef.current[0] : defaultSkill;
        let skill = defaultFromBackend;

        if (curSkill?.ability_id) {
            skill = curSkill;
        }

        if (currentSessionMapIdRef.current) {
            resetSession({ skill });
        } else {
            ToastUtils.showToast('已经是最新对话了');
        }
    };
    //当前ai回答的消息更新时，更新消息列表
    const updateMsgListByCurmsg = (currentMsg, processing, msgList, localsession_key) => {
        // 判断是否为 DeerFlow 聊天
        const isDeerFlow = curSkillRef.current?.third_json?.handler === 'deerflow';
        let effectiveSessionId = currentMsg.session_id;

        if (isDeerFlow) {
            // 将 DeerFlow 路由与处理逻辑移到专用函数
            const returnedId = routeDeerFlowMessage({
                curSkillRef,
                currentMsg,
                currentSessionMapIdRef,
                linkToSession,
                deerFlowHook,
                processing,
                msgList,
                localsession_key,
                sessionListRef,
                sessionMapRef,
                formatSessionList,
                changeSessionMapItem,
                isInAnswerRef,
                side
            });
            if (returnedId) effectiveSessionId = returnedId;
        }

        //新会话处理
        if ((localsession_key || isDeerFlow) && !sessionMapRef.current[effectiveSessionId]) {
            let curList = sessionListRef.current ? sessionListRef.current : [];
            let localList = curList[0];

            if (!isDeerFlow && localsession_key) {
                // 非 DeerFlow 新会话的原有逻辑

                let fileName =
                    currentMsg?.file_json[0]?.title || `${currentMsg?.file_json[0]?.name}.${currentMsg?.file_json[0]?.ext_type}` || '新会话';
                if (isCaseSimulationType(curSkillRef.current?.ability_id)) {
                    fileName = currentMsg?.component?.title;
                }
                curList[0] = {
                    ...localList,
                    status: currentMsg?.status,
                    session_name: currentMsg.question || fileName,
                    session_id: effectiveSessionId,
                    // 🔥 修复：保留 handler_json，确保跳转到真实会话ID后技能类型不丢失
                    handler_json: localList?.handler_json || []
                };

                let data = [...curList];

                // 非 DeerFlow 会话的原有跳转逻辑
                if (currentSessionMapIdRef.current === localsession_key) {
                    currentSessionMapIdRef.current = effectiveSessionId;
                    linkToSession(effectiveSessionId, { replace: true });
                }

                formatSessionList(data);
            }
        }

        const cloneMessages = cloneDeep(msgList);
        //找到正在生成的消息
        let index = cloneMessages.findIndex((item) => {
            let targetId = item._id || item.temId;
            // 确保只匹配AI消息，避免匹配到用户消息
            return targetId === currentMsg.temId && item.role === 'ai';
        });

        if (index !== -1) {
            let data = {
                ...cloneMessages[index],
                ...currentMsg,
                // 如果 currentMsg.content 有值（包括空字符串），就使用它
                content: currentMsg.content !== undefined && currentMsg.content !== null ? currentMsg.content : cloneMessages[index].content || '',
                // 确保 processing 字段被正确传递（从 currentMsg 或根据 processing 参数设置）
                processing: currentMsg.processing !== undefined ? currentMsg.processing : processing
            };
            cloneMessages[index] = data;
            //新会话结束后 更新会话历史列表
            if (processing === false) {
                changeSessionMapItem(effectiveSessionId, { loading: false });
                isInAnswerRef.current = false;
                if (isNeedGetSessionListRef.current && side === 'web') {
                    isNeedGetSessionListRef.current = false;
                    //  修复：调用获取会话列表函数更新最近会话
                    // getSessionList({
                    //     user_id: getUserId(),
                    //     agent_id: agentId
                    // });
                }

                // DeerFlow 后处理（清理延迟定时器、重置按钮禁用状态）
                handleDeerFlowPostMessageCleanup({
                    isDeerFlow,
                    effectiveSessionId,
                    deerFlowHook
                });
            } else {
                // 确保处理中的消息状态正确设置
                changeSessionMapItem(effectiveSessionId, { loading: true });
                isInAnswerRef.current = true;
            }

            let res = handleMessages(cloneMessages);

            // 🔥 检测是否为带引用的多模态消息，如果有内容则不显示loading
            let finalLoading = processing === false ? false : true;
            try {
                const isMultimodalRef =
                    currentMsg?.multimodal_reference || (Array.isArray(currentMsg?.references) && currentMsg.references.length > 0);
                const curContent =
                    currentMsg?.content !== undefined && currentMsg?.content !== null
                        ? String(currentMsg.content)
                        : String(cloneMessages[index]?.content || '');
                const hasContent = curContent && curContent.trim() !== '';
                if (isMultimodalRef && hasContent) {
                    finalLoading = false;
                }
            } catch (e) {
                console.log(e, 'e');
            }

            changeSessionMapItem(
                effectiveSessionId,
                {
                    messages: res,
                    loading: finalLoading
                },
                cloneMessages
            );
        }
    };
    //不生成新消息，在原消息上发送消息
    const createRequestByMsgId = (msgId, requestChatParams) => {
        let { session_id } = requestChatParams;
        let oldMessages = originMsgMapRef.current[session_id]?.messages || [];
        let len = oldMessages.length;
        let obj = {
            nextId: msgId,
            msgList: oldMessages,
            requestChatParams: requestChatParams,
            status: 'complete'
        };
        handleChat(obj, oldMessages[len - 1]);
    };

    const isTargetSkillType = (skillId, type) => {
        const handlerValue = third_json_handler[type] || type;
        // 🔥 修复：如果提供的 skillId 就是当前技能的 ID，直接使用 curSkillRef
        // 这样可以避免因为 session.skill_id 不是真实 ability_id 导致的查找失败
        if (curSkillRef?.current && String(curSkillRef.current.ability_id) === String(skillId)) {
            return curSkillRef.current.third_json?.handler === handlerValue;
        }

        // 尝试通过 ability_id 查找
        let temSkill = skillListRef.current.find((ele) => ele && String(ele.ability_id) === String(skillId));

        // curSkill.ability_name === 'ChatBI技能'
        if (temSkill?.third_json?.handler === handlerValue) {
            return true;
        }
        return false;
    };

    const isDeerFlowType = (skillId) => {
        return deerFlowHook.isDeerFlowType(skillId, skillListRef);
    };
    const isChatBIype = (skillId) => {
        return isTargetSkillType(skillId, third_json_handler.chatbi);
    };
    const isAipptType = (skillId) => {
        return isTargetSkillType(skillId, third_json_handler.aippt);
    };
    const isFileChatType = (skillId) => {
        return isTargetSkillType(skillId, third_json_handler.file_chat);
    };
    const isMultimodalLearningType = (skillId) => {
        return isTargetSkillType(skillId, third_json_handler.multimodal);
    };
    const isCaseSimulationType = (skillId) => {
        return isTargetSkillType(skillId, third_json_handler.case_simulation);
    };
    const handlePaste = (e) => {
        useUsualSkillHook.handlePaste(e, { agentFile, setAgentFile, curSkill, isFileChatType, references, setReferences });
    };
    //创建会话请求
    const createRequest = (nextId, msgList, requestChatParams, isNewSession = false) => {
        const isDeerFlow = isDeerFlowType(requestChatParams.skill_id);
        if (isDeerFlow) {
            deerFlowHook.createDeerFlowRequest(nextId, msgList, requestChatParams, isNewSession, {
                updateMsgListByCurmsg,
                handleMessages,
                changeSessionMapItem,
                changeOriginMsgMapRef,
                originMsgMapRef,
                isInAnswerRef,
                currentSessionMapIdRef,
                checkIsLogin,
                historyPollingTimers: deerFlowHook.historyPollingTimers // 🔥 传递轮询定时器管理器
            });
            return;
        } else {
            let obj = {
                nextId: nextId,
                msgList: msgList,
                requestChatParams: requestChatParams
            };
            handleChat(obj);
        }
    };
    const onClickCitation = (data) => {
        if (data.type === contentType.web_search) {
            window.open(data.url);
        }
        if (side === 'mobile' && data.type === contentType.retrieval) {
            showMobileFileDetail(data);
        }
    };

    // 不需要底部操作按钮的消息类型（课程推荐、AI评阅、文件对话、多模态学习等）
    const noFooterTypes = [
        contentType.recommend_course,
        contentType.ai_evaluation,
        contentType.file_chat,
        contentType.multimodal_learning,
        contentType.multimodal
    ];
    // const ImagePreview = ({ file }) => {
    //     if (!file || !file.file_url) return null;

    //     return (
    //         <div className="image-preview">
    //             <img
    //                 src={file.file_url}
    //                 alt="截图"
    //                 style={{ maxWidth: '100%', maxHeight: '300px' }}
    //                 onError={(e) => {
    //                     console.error('图片加载失败:', e);
    //                     e.target.src = '/default-image.png'; // 设置默认图片
    //                 }}
    //             />
    //         </div>
    //     );
    // };
    useEffect(() => {
        hideTTSActionsRef.current = hideTTSActions;
        if (currentSessionMapIdRef.current && sessionMapRef.current[currentSessionMapIdRef.current]) {
            const currentMessages = originMsgMapRef.current[currentSessionMapIdRef.current]?.messages || [];
            const updatedMessages = handleMessages(currentMessages);
            changeSessionMapItem(
                currentSessionMapIdRef.current,
                {
                    messages: updatedMessages
                },
                currentMessages
            );
        }
    }, [hideTTSActions]);
    const isNoFooterSkills = () => {
        return (
            isDeerFlowType(curSkillRef.current?.ability_id) ||
            isFileChatType(curSkillRef.current?.ability_id) ||
            isCaseSimulationType(curSkillRef.current?.ability_id)
        );
    };
    //会话过程中--处理页面显示的消息列表--，如果处理历史记录先使用 handelSessionHistoryMessage
    const handleMessages = (messages, from = 'chat') => {
        let inInanswer = false; // 默认不在回答中，避免隐藏按钮

        // 只有最新的消息才会考虑loading状态
        // 只有当前正在处理的新消息才应该隐藏按钮
        if (from === 'chat' && sessionMapRef.current[currentSessionMapIdRef.current]?.loading) {
            inInanswer = true;
        }

        // 过滤掉隐藏的消息（如researcher和reporter消息）
        const filteredMessages = messages.filter((msg) => !msg.isHidden);
        const cloneMsg = cloneDeep(filteredMessages);
        // console.log(cloneMsg, 'cloneMsg');
        let len = filteredMessages.length;

        let res = [];
        if (len > 0) {
            res = cloneMsg.map((item, index) => {
                let {
                    content,
                    content_type,
                    status,
                    role,
                    handler,
                    web_result = null,
                    retrieval_result = null,
                    file_json = [],
                    references = [],
                    multimodal_reference = null,
                    recommend_course_result,
                    multimodal_learning_result,
                    ai_evaluation,
                    component = null,
                    card_result = null,
                    processing = false
                } = item;
                const currentHideTTSActions = hideTTSActionsRef.current;

                const itemHandler = item.handler || item.multimodal;
                const isMultimodalHandler = itemHandler === contentType.multimodal_learning || itemHandler === contentType.multimodal;
                let finalContent = content;
                let loadingValue = status === 'loading';
                if (isMultimodalHandler) {
                    // 🔥 检查是否有引用状态（multimodal_reference 或 references）
                    const hasReference = multimodal_reference || (Array.isArray(references) && references.length > 0);

                    if (hasReference) {
                        // 有引用状态时，根据内容情况决定是否显示三个点
                        const hasContent = finalContent && typeof finalContent === 'string' && finalContent.trim() !== '';
                        if (!hasContent && status === 'loading') {
                            // 没有内容且还在loading时，显示三个点
                            loadingValue = true;
                        } else {
                            // 有内容时，流式输出，不显示三个点
                            loadingValue = false;
                        }
                    }
                }

                return {
                    status,
                    loadingRender: () => {
                        return <DotLoading></DotLoading>;
                    },
                    loading: loadingValue,
                    role: role === 'local' ? 'local' : 'ai', // 保持原始角色，不要强制转换
                    content: finalContent,
                    footer:
                        role === 'local' ||
                        noFooterTypes.includes(content_type) ||
                        isNoFooterSkills() ||
                        ai_evaluation ||
                        multimodal_learning_result ||
                        isMultimodalHandler ? null : status === 'complete' ? (
                            <div
                                data-side={side}
                                data-answer={index === len - 1 && inInanswer ? 'true' : 'false'} // 只对最新消息应用inInanswer
                                className={`ai-action-wrap ${index === len - 1 ? 'last-msg' : 'previous-msg'}`}
                            >
                                {/* <Display show={side === 'mobile' ? (index === messages.length - 1 ? true : false) : true}> */}
                                <></>
                                <Display show={!recommend_course_result && hideTTSActionsRef.current}>
                                    <Copy
                                        side={side}
                                        className={`ai-copy-icon ${index !== len - 1 && deerFlowHook.planButtonsDisabled ? 'disabled' : ''}`}
                                        onClick={(e) => {
                                            if (index !== len - 1 && deerFlowHook.planButtonsDisabled) return;
                                            copy(item);
                                        }}
                                    ></Copy>

                                    <Display show={skillStore?.skillAvailable}>
                                        <Regenerate
                                            side={side}
                                            className={`ai-generate-icon ${index !== len - 1 && deerFlowHook.planButtonsDisabled ? 'disabled' : ''}`}
                                            onClick={() => {
                                                if (index !== len - 1 && deerFlowHook.planButtonsDisabled) return;
                                                reGenerate(item);
                                            }}
                                            // style={{
                                            //     display: item?.plugin_json?.voice_call && !isInVoiceCall ? 'none' : 'inline-block'
                                            // }}
                                        ></Regenerate>
                                    </Display>
                                </Display>
                                <Display show={!recommend_course_result && hideTTSActionsRef.current}>
                                    <FeedBack
                                        side={side}
                                        className="ai-feed-back-icon"
                                        onClick={() => {
                                            feedBack(item);
                                        }}
                                    ></FeedBack>
                                </Display>
                            </div>
                        ) : null,
                    messageRender: (message) => {
                        // 修复：正确区分AI和用户消息，确保用户消息不被当作AI消息处理
                        if (role !== 'local') {
                            // 检查消息是否为React组件
                            return renderAiMessage({
                                message,
                                from,
                                index,
                                len,
                                item,
                                deerFlowHook,
                                onSubmitMsg,
                                skillStore,
                                retrieval_result,
                                web_result,
                                content_type,
                                processing,
                                recommend_course_result,
                                multimodal_learning_result,
                                ai_evaluation,
                                card_result,
                                handleMessages,
                                setDetailPanelOpen,
                                setMultimodalReference,
                                detailPanelOpen,
                                activeDetailMessageId,
                                setActiveDetailMessageId,
                                changeSessionMapItem,
                                getCurSessionMsgs,
                                changeOriginMsgMapRef,
                                originMsgMapRef,
                                currentSessionMapIdRef,
                                createRequestByMsgId,
                                onClickCitation,
                                getBaseParams,
                                side,
                                currentAgent
                            });
                        }
                        return (
                            <>
                                <Display show={references && references?.length}>
                                    <References
                                        curSkillRef={curSkillRef}
                                        curSkill={curSkill}
                                        isTargetSkillType={isTargetSkillType}
                                        side={side}
                                        files={references}
                                        from="chat"
                                    ></References>
                                </Display>
                                <Display show={side === 'web' && multimodal_reference}>
                                    <MultimodalReference
                                        data={multimodal_reference}
                                        from="chat"
                                        onClick={() => {
                                            // 聊天记录点击只同步到输入区，不直接弹列表
                                            if (setMultimodalReference) {
                                                setMultimodalReference(multimodal_reference);
                                            }
                                        }}
                                    />
                                </Display>
                                <Display show={file_json && Array.isArray(file_json) && file_json.length}>
                                    {/* <AgentFile side={side} fileList={file_json} from="chat" /> */}
                                    <ChatFiles side={side} fileList={file_json} />
                                </Display>
                                <Display show={component}>
                                    <UserMessage card={component}></UserMessage>
                                </Display>
                                <Display show={message}>
                                    <div className="ai-user-question-wrap">
                                        <div className="ai-user-question">{message}</div>
                                    </div>
                                </Display>
                            </>
                        );
                    }
                };
            });
        }
        return res;
    };
    const isNewChat = (session_id) => {
        return Number(session_id) === 0;
    };
    //发送并接收聊天数据
    const handleChat = (params, appendData = false) => {
        let flowMsg = new FlowMsg();
        const { requestChatParams, msgList, nextId } = params;
        // console.log(msgList, 'msgListmsgList');
        let latestMsg = {};
        isInAnswerRef.current = true;
        //当前消息 属于哪个会话
        let curSessionId = requestChatParams.session_key ? requestChatParams.session_key : requestChatParams.session_id;
        let reqAgent = agent;
        if (isFileChatType(curSkillRef.current?.ability_id)) {
            requestChatParams.tenant_id = Storage.get('tenantId');
            reqAgent = basicAgent;
        }
        if (isCaseSimulationType(curSkillRef.current?.ability_id)) {
            reqAgent = simulationAgent;
        }
        if (isNewChat(requestChatParams.session_id)) {
            requestChatParams.session_id = '0';
        }
        if (isMultimodalLearningType(curSkillRef.current?.ability_id)) {
            reqAgent = multimodalAgent;
        }
        reqAgent.request(requestChatParams, {
            onSuccess: (response) => {
                // changeSessionMapItem(currentSessionMapIdRef.current, { loading: false });
                setLoading(false);
            },
            onUpdate: (message) => {
                // changeSessionMapItem(currentSessionMapIdRef.current, { loading: false });
                setLoading(false); //暂时解决加载时会出现think标签的问题
                if (message.data) {
                    const data = JSON.parse(message.data);
                    console.log(data, 'data');
                    let { answer, event, success, ...otherParams } = data;
                    flowMsg.handleFlowMsg(data, appendData);
                    latestMsg = {
                        ...requestChatParams,
                        ...otherParams,
                        temId: nextId,
                        answerContent: flowMsg.answerContent,
                        content: flowMsg.messageResult,
                        web_result: flowMsg.web_result,
                        retrieval_result: flowMsg.retrieval_result,
                        course_result: flowMsg.course_result,
                        // Consider multimodal and recommend results as completion signals
                        // 对于多模态引用消息，如果有内容就设置为完成状态
                        status:
                            flowMsg.answerContent ||
                            flowMsg.answerContent ||
                            flowMsg.messageResult ||
                            flowMsg.ai_evaluation ||
                            flowMsg.multimodal_learning_result ||
                            flowMsg.recommend_course_result ||
                            flowMsg.card_result
                                ? 'complete'
                                : 'loading',
                        recommend_course_result: flowMsg.recommend_course_result,
                        multimodal_learning_result: flowMsg.multimodal_learning_result,
                        ai_evaluation: flowMsg.ai_evaluation,
                        // 对于多模态引用消息，如果有内容就停止加载状态
                        processing: flowMsg.answerContent ? false : flowMsg.processing,
                        card_result: flowMsg.card_result
                    };
                    //新会话第一次会话结束后，需要查询会话列表
                    if (side === 'web' && isNewChat(requestChatParams.session_id) && isHasNewSessionIdRef.current === false && latestMsg.session_id) {
                        isNeedGetSessionListRef.current = true;
                    }

                    // 如果消息中包含研究计划数据，重置修改计划模式
                    if (
                        isDeerFlowType(requestChatParams.skill_id) &&
                        latestMsg.content &&
                        latestMsg.content.includes('{') &&
                        latestMsg.content.includes('"title"') &&
                        latestMsg.content.includes('"steps"') &&
                        !flowMsg.processing
                    ) {
                        // 消息处理完成后，自动退出修改计划模式
                        deerFlowHook.resetEditPlanMode();
                    }
                } else {
                    ToastUtils.showToast(message.msg || '错误');
                    latestMsg = {
                        ...requestChatParams,
                        temId: nextId,
                        content: message.msg || '错误',
                        web_result: [],
                        retrieval_result: [],
                        status: 'complete'
                    };
                }

                updateMsgListByCurmsg(latestMsg, flowMsg.processing, msgList, requestChatParams.session_key);
            },
            onError: (error) => {
                console.error(error);
                changeSessionMapItem(curSessionId, { loading: false });
                setLoading(false);
            }
        });
    };

    //发送消息前 处理消息列表，追加提问消息及AI 回答中的loading消息
    const beforeSubmitMsg = (requestChatParams, isPreQuestion) => {
        let session_id = requestChatParams?.session_id;
        let nextContent = requestChatParams?.question;
        let file_json = requestChatParams?.file_json;
        let references = requestChatParams?.references || [];
        //新会话
        const isNewSession = !session_id || session_id === '0';
        const isDeerFlow = isDeerFlowType(requestChatParams.skill_id);
        if (isNewSession) {
            if (isDeerFlow) {
                // 使用DeerFlow hook处理新会话
                const result = deerFlowHook.handleDeerFlowBeforeSubmit(requestChatParams, isNewSession, {
                    currentSessionMapIdRef,
                    sessionListRef,
                    formatSessionList,
                    linkToSession,
                    changeOriginMsgMapRef,
                    originMsgMapRef
                });
                session_id = result.session_id;
            } else {
                // 非 DeerFlow 会话使用生成的 UUID
                session_id = getuuid();
                currentSessionMapIdRef.current = session_id;
                linkToSession(session_id, { replace: true });
                ConfigFactory(session_id, session_id);
                requestChatParams.session_key = session_id;
                let curList = sessionListRef.current ? sessionListRef.current : [];
                // 🔥 修复：添加 handler_json 字段，确保刷新后能正确识别技能类型
                const handler = curSkillRef.current?.third_json?.handler;
                let data = [
                    {
                        session_name: '新会话',
                        time_range: '1',
                        session_id: session_id,
                        skill_id: requestChatParams?.skill_id,
                        handler_json: handler ? [handler] : [] // 添加 handler_json
                    },
                    ...curList
                ];
                formatSessionList(data);
            }
        } else if (isDeerFlow) {
            // 现有DeerFlow会话的处理
            deerFlowHook.handleDeerFlowBeforeSubmit(requestChatParams, isNewSession, {
                currentSessionMapIdRef,
                sessionListRef,
                formatSessionList,
                linkToSession,
                changeOriginMsgMapRef,
                originMsgMapRef
            });
        }

        // 确保使用当前会话的 session_id
        const currentSessionId = currentSessionMapIdRef.current || session_id;

        // let oldMessages = sessionMapRef.current[session_id]?.messages || [];
        let oldMessages = originMsgMapRef.current[currentSessionId]?.messages || [];

        let len = oldMessages.length;
        const myLocalId = 'msg_' + len;
        const aiLocalId = 'msg_' + (len + 1);

        // 🔥 优先从 requestChatParams 中读取摘要（从 submitMsg 传递过来的），如果没有则从 ref 读取
        const currentMultimodalReference = !isPreQuestion ? requestChatParams.multimodal_reference || multimodalReferenceRef.current : null;
        const sanitizedMultimodalReference = currentMultimodalReference
            ? {
                  title: currentMultimodalReference.title || '多模态学习',
                  description: currentMultimodalReference.description || '',
                  videoCount: currentMultimodalReference.videoCount || 0,
                  firstVideoTitle: currentMultimodalReference.firstVideoTitle || '',
                  reference_id: currentMultimodalReference.reference_id,
                  // 保留 onListClick，保证聊天记录里的引用也能直接展开视频列表
                  onListClick: currentMultimodalReference.onListClick
              }
            : null;

        const newMessages = [
            ...oldMessages,
            {
                ...requestChatParams,
                role: 'local',
                status: 'complete',
                temId: myLocalId,
                content: nextContent,
                file_json: file_json,
                references: references,
                multimodal_reference: sanitizedMultimodalReference
            },
            {
                role: 'ai',
                status: 'loading',
                temId: aiLocalId,
                question: nextContent,
                content: '',
                handler: curSkillRef.current?.third_json?.handler
            }
        ];

        setLoading(true);
        let res = handleMessages(newMessages);
        console.log(res, 'ressssss');
        // 使用当前会话ID更新消息
        changeSessionMapItem(currentSessionId, { loading: true, messages: res }, newMessages);

        // 针对DeerFlow的特殊处理
        if (isDeerFlowType(requestChatParams.skill_id)) {
            // 设置session status为0（表示正在加载中）
            changeOriginMsgMapRef({
                [currentSessionId]: {
                    ...originMsgMapRef.current[currentSessionId],
                    status: 0
                }
            });

            // 除了"修改计划"或"开始研究"外，不带 threadId
            if (!deerFlowHook.editPlanMode && requestChatParams.value !== 'start_research') {
                delete requestChatParams.threadId;
            }
        }
        if (!preQuestionHook.canClickRef.current) {
            preQuestionHook.setCanClick(true);
        }
        //发送时只要带附件就要更新引用文件
        if (!isPreQuestion && agentFile.length && isFileChatType(requestChatParams.skill_id)) {
            // let temdata = agentFile.filter((ele) => ele.status === fileStatusDic.success && ele.parse_status === parseStatusDic.success);
            setReferences(file_json);
        }

        createRequest(aiLocalId, newMessages, requestChatParams, isNewSession);
    };
    //保存时插件字段处理
    const getPluginJson = (curPlugin) => {
        let obj = {};
        if (curPlugin) {
            curPlugin.forEach((ele) => {
                obj[ele.name] = true;
            });
        }

        //如果插件配置了保持开启，需要将对应字段设为true
        if (curSkillRef?.current?.plugin_json) {
            curSkillRef?.current?.plugin_json.forEach((item) => {
                if (item.choice === 1) {
                    obj[item.name] = true;
                }
            });
        }

        return obj;
    };

    const clearSendData = () => {
        setContent('');
        setAgentFile([]);
        // setReferences([]);
    };
    const isSkillNeedLogin = (skill) => {
        let targetSkill = skill || curSkillRef?.current;
        // 🔥 优化：根据 login_restrict 字段判断是否需要登录
        // login_restrict = 0: 不需要登录
        // login_restrict = 1: 需要登录
        // 如果字段不存在，默认需要登录
        if (targetSkill?.login_restrict === 0) {
            return false; // 明确标记为不需要登录
        }
        if (targetSkill?.login_restrict === 1) {
            return true; // 需要登录
        }
        // 兜底：如果没有 login_restrict 字段，默认需要登录（保持向后兼容）
        return true;
    };
    const authTest = async () => {
        if (isSkillNeedLogin()) {
            let isLogin = await checkIsLogin();
            if (!isLogin) {
                return false;
            }

            let isCanUse = await checkCanUse();
            if (!isCanUse) {
                return false;
            }
        }
        return true;
    };

    const getBaseParams = () => {
        return {
            user_id: getUserId(),
            agent_id: agentId,
            session_id: currentSessionMapIdRef.current || '0',
            tenant_id: Storage.get('tenantId'),
            plugin_json: getPluginJson(curpluginRef?.current),
            skill_id: curSkillRef?.current?.ability_id ? String(curSkillRef.current.ability_id) : ''
        };
    };

    const onSubmitMsg = async (params, isPreQuestion = false) => {
        console.log(isPreQuestion, 'isPreQuestion');
        if (!preQuestionHook.canClickRef.current) {
            ToastUtils.showToast('当前正在生成结果，请稍后操作');
            return false;
        }
        if (!isCanSendMsg(params.question, isPreQuestion)) {
            return false;
        }
        preQuestionHook.setCanClick(false);
        params.question = params.question.trim();

        if (!isPreQuestion) {
            params.file_json = agentFile.filter((ele) => ele.status === fileStatusDic.success && ele.parse_status === parseStatusDic.success);
            params.references = references;
            clearSendData();
        } else {
            params.file_json = [];
            params.references = [];
        }

        // 🔥 新增：检查当前技能是否已下架（left_side === 0），如果下架则切换到通用技能
        if (curSkillRef.current && curSkillRef.current.left_side === 0) {
            console.warn('⚠️ 当前技能已下架，切换到通用技能发送消息');
            // 🔥 修复：查找通用技能（ability_id === -1），而不是菜单第一个技能
            const generalSkill = skillListRef.current.find((ele) => String(ele.ability_id) === '-1') || defaultSkill;
            setCurSkill(generalSkill);
        }

        // 发送消息时无论是否处于修改计划模式，都禁用所有计划按钮
        deerFlowHook.setPlanButtonsDisabled(true);
        const requestChatParams = {
            user_id: getUserId(),
            agent_id: agentId,
            session_id: currentSessionMapIdRef.current || '0',
            tenant_id: Storage.get('tenantId'),
            plugin_json: getPluginJson(curpluginRef?.current),
            skill_id: curSkillRef?.current?.ability_id ? String(curSkillRef.current.ability_id) : '',
            // skill_name: curSkill?.ability_name || '',
            // skill_describe: curSkill?.description || '',
            apart: curSkillRef.current?.apart,
            ...params
        };

        // 使用DeerFlow hook处理计划按钮相关逻辑
        if (isDeerFlowType(curSkillRef?.current?.ability_id)) {
            deerFlowHook.handleDeerFlowPlanButton(requestChatParams, {
                onSubmitMsg,
                setEditPlanMode: deerFlowHook.setEditPlanMode
            });
        }
        let isNeedCheckCanuse = false;
        if (isSkillNeedLogin()) {
            let isLogin = await checkIsLogin();
            if (!isLogin) {
                return false;
            }
            isNeedCheckCanuse = true;
        } else {
            let isLogin = await checkIsLogin(false); //不需要跳转到登录页
            if (isLogin) {
                isNeedCheckCanuse = true;
            }
        }
        //登录状态下 新会话需要调用此接口以保证学员能够正确添加
        if (isNeedCheckCanuse && isNewChat(requestChatParams.session_id)) {
            let isCanUse = await checkCanUse();
            if (!isCanUse) {
                return false;
            }
        }
        // 处理DeerFlow特殊逻辑（如"开始研究"）
        // 注意：DeerFlow的"开始研究"逻辑现在在handleDeerFlowPlanButton中处理

        beforeSubmitMsg(requestChatParams, isPreQuestion);
    };
    //重新生成
    const reGenerate = (info) => {
        let curSession = sessionMapRef.current[currentSessionMapIdRef.current];
        if (curSession.loading) {
            return false;
        }
        changeSessionMapItem(currentSessionMapIdRef.current, { loading: true });
        console.log(info);
        console.log(sessionMapRef.current, '当前会话');

        if (!info) {
            return false;
        }
        // let requestChatParams = {
        //     session_id: info?.session_id || currentSessionMapIdRef.current,
        //     plugin_json: getPluginJson(curpluginRef?.current || info?.plugin),
        //     skill_id: curSkillRef?.current?.ability_id || info?.skill_id || '',
        //     question: info?.question
        // };
        let requestChatParams = {
            session_id: info?.session_id || currentSessionMapIdRef.current,
            question: info?.question
        };
        onSubmitMsg(requestChatParams);
    };
    //复制
    const copy = (info) => {
        console.log(info, 'info');
        let str = info.answerContent;
        str = removeTagsAndContent(str, 'citation');
        str = str.replace(/[\r\n]/g, '');
        navigator.clipboard.writeText(str);
        // ToastUtils.showToast('复制成功');
    };
    const feedBack = (info) => {
        console.log(info);
        if (side === 'web') {
            handleFeedBack(info, checkIsLogin);
        } else {
            handleMobileFeedBack(info, checkIsLogin);
        }
    };
    //复制
    // const copy = (info) => {
    //     console.log(info.answerContent, '哈哈');
    //     let str = '';
    //     const parser = new DOMParser();
    //     // 将 HTML 字符串解析为文档对象
    //     const doc = parser.parseFromString(info.content, 'text/html');

    //     // 查找所有 answer 标签
    //     const answerTags = doc.querySelectorAll('.ai-answer-box');

    //     if (answerTags.length) {
    //         str = answerTags[0].innerHTML;
    //     }

    //     str = removeHtmlTags(str);
    //     str = str.replace(/[\r\n]/g, '');
    //     navigator.clipboard.writeText(str);
    //     ToastUtils.showToast('复制成功');
    // };
    //处理历史记录数据--整理成前端需要的格式
    const formatHistoryRecord = async (data, session) => {
        let temData = await formatHistoryData(data, session?.session_id); //后端返回来的处理后的数据
        // console.log(temData, '处理的');

        // 🔥 使用 hook 中提取的函数创建历史记录视频列表打开函数
        const openHistoryMultimodalList = createOpenHistoryMultimodalList({
            setDetailPanelOpen,
            setActiveDetailMessageId,
            setMultimodalReference
        });

        // 🔥 新增：处理用户消息的 references 字段，转换为 multimodal_reference 格式
        temData.forEach((item) => {
            if (item.role === 'local' && item.references && Array.isArray(item.references) && item.references.length > 0) {
                const videoReferences = item.references.filter((ref) => ref.image_url || ref.title);
                if (videoReferences.length > 0) {
                    item.multimodal_reference = {
                        title: '多模态学习',
                        description: '',
                        videoCount: videoReferences.length,
                        firstVideoTitle: videoReferences[0]?.title || '',
                        reference_id: item.reference_id || null,
                        // 列表按钮点击时打开视频列表
                        onListClick: () => openHistoryMultimodalList(videoReferences)
                    };
                }
            }
        });

        // data.forEach((ele) => {
        //     ele.role = ele.role === 'user' ? 'local' : 'ai';
        //     ele.session_id = session?.session_id;
        //     ele.status = 'complete';
        //     if (ele.role === 'ai') {
        //         //用两个\n是为了解决拼接div后 富文本解析不成功的问题
        //         ele.content = `<div data-think=${ele?.deep_think} class='ai-answer-box'>\n\n${ele.content}\n\n</div>`;
        //         if (ele?.deep_think) {
        //             let thinkResult = `<think>\n${ele.reasoning_content}\n</think>`;
        //             ele.content = `${thinkResult}${ele.content}`;
        //         }
        //     } else {
        //         ele.content = ele.content;
        //     }
        // });
        let res = handleMessages(temData, 'history'); //页面展示的数据----antdx--
        return {
            showMsg: res,
            allMsg: temData
        };
    };

    //处理当前会话及对应的历史消息列表
    const handelSessionHistoryMessage = async (historyMessage, session = {}) => {
        let { showMsg, allMsg } = await formatHistoryRecord(historyMessage, session);
        console.log(allMsg, 'allMsgallMsg');
        // 🔥 修正：检查最后一条AI消息的content是否为空（判断是否需要轮询）
        const lastMessage = allMsg.length > 0 ? allMsg[allMsg.length - 1] : null;
        const lastAiMessage = [...allMsg].reverse().find((msg) => msg.role === 'ai');

        // 判断是否需要轮询的条件：
        // 1. 最后一条消息是用户消息（等待AI回复）
        // 2. 或者最后一条AI消息的content为空（AI还在生成中）
        // 3. 🔥 新增：对于DeerFlow报告，检查是否有未完成的报告任务
        const hasUnrepliedUserMessage = lastMessage && lastMessage.role === 'local' && lastMessage.status === 'complete';
        const hasEmptyAiResponse = lastAiMessage && (!lastAiMessage.content || lastAiMessage.content.trim() === '');

        // 检查是否有加载或回答状态的消息
        const hasLoadingMessage = allMsg.some((msg) => msg.status === 'loading');
        const hasAnsweringMessage = allMsg.some((msg) => msg.status === 'answering');

        // 🔥 新增：对于DeerFlow报告，检查本地存储的canPause状态
        let hasDeerFlowReportInProgress = false;
        let shouldKeepClickable = false; // 🔥 新增：记录是否应该保持按钮可点击
        if (isDeerFlowType(session?.skill_id)) {
            // 🔥 修复：正确读取数组格式的本地存储数据
            const historySessions = JSON.parse(localStorage.getItem('grt_history_sessions') || '[]');
            const localSessionData = historySessions.find((item) =>
                typeof item === 'object' ? item.sessionId === session?.session_id : item === session?.session_id
            );

            // 如果本地存储中canPause为true，表示该会话需要继续轮询
            const shouldContinuePolling = localSessionData?.canPause === true;

            // 🔥 新增：如果本地存储中isClickable为true，表示该会话的暂停按钮应该可点击
            shouldKeepClickable = localSessionData?.isClickable === true;

            // 同时检查originMsgMapRef中的状态
            const sessionData = originMsgMapRef.current[session?.session_id];
            const hasInProgressStatus = sessionData && (sessionData.status === 0 || sessionData.status === 1);

            hasDeerFlowReportInProgress =
                shouldContinuePolling ||
                hasInProgressStatus ||
                (isDeerFlowType(session?.skill_id) && (hasUnrepliedUserMessage || hasEmptyAiResponse));
        }

        // 🔥 修复：检查是否需要轮询获取AI回复
        const needsPolling =
            (isDeerFlowType(session?.skill_id) || isAipptType(session?.skill_id)) &&
            (hasUnrepliedUserMessage || hasEmptyAiResponse || hasDeerFlowReportInProgress);

        // 🔥 修复：特殊处理DeerFlow会话的loading状态
        // 对于DeerFlow会话，如果本地存储中canPause为false，说明任务已完成，不应该显示loading
        let isLoading = hasLoadingMessage || needsPolling;
        if (isDeerFlowType(session?.skill_id)) {
            const historySessions = JSON.parse(localStorage.getItem('grt_history_sessions') || '[]');
            const localSessionData = historySessions.find((item) =>
                typeof item === 'object' ? item.sessionId === session?.session_id : item === session?.session_id
            );

            // 如果本地存储明确标记canPause为false，且没有真正的loading消息，则不应该loading
            if (localSessionData?.canPause === false && !hasLoadingMessage && !hasAnsweringMessage) {
                isLoading = false;
            }
        }

        const isAnswering = hasAnsweringMessage;

        const sessionState = {
            messages: showMsg,
            loading: isLoading,
            answering: isAnswering
        };

        // 🔥 如果检测到加载状态，同时更新originMsgMapRef中的status
        if (isLoading || isAnswering) {
            changeOriginMsgMapRef({
                [session?.session_id]: {
                    ...originMsgMapRef.current[session?.session_id],
                    messages: allMsg,
                    status: isLoading ? 0 : isAnswering ? 1 : null // 0表示加载中，1表示回答中
                }
            });
        } else {
            // 🔥 新增：如果不是loading状态，确保清除status
            changeOriginMsgMapRef({
                [session?.session_id]: {
                    ...originMsgMapRef.current[session?.session_id],
                    messages: allMsg,
                    status: null // 清除状态
                }
            });
        }

        changeSessionMapItem(session?.session_id, sessionState, allMsg);

        // 🔥 新增：如果检测到研究任务正在进行且需要保持按钮可点击，确保本地存储状态正确
        if (isDeerFlowType(session?.skill_id) && (needsPolling || shouldKeepClickable)) {
            syncHistorySessionClickable(session, needsPolling, shouldKeepClickable, originMsgMapRef);
        }

        if (needsPolling) {
            // 🔥 修复：只有非DeerFlow会话才启动useChat中的轮询
            // DeerFlow会话的轮询已经在handleDeerFlowChatWithUI中处理
            if (!isDeerFlowType(session?.skill_id)) {
                // 启动轮询，定期检查是否有新的AI回复
                deerFlowHook.startHistoryPolling(session, {
                    formatHistoryRecord,
                    changeSessionMapItem,
                    changeOriginMsgMapRef,
                    originMsgMapRef,
                    currentSessionMapIdRef,
                    skillListRef
                });
            } else {
                // 对于DeerFlow会话，执行一次性检查以确保状态同步（使用外部 helper）
                setTimeout(() => {
                    syncDeerFlowSessionPolling(session, {
                        handleDeerFlowHistory,
                        formatHistoryRecord,
                        changeSessionMapItem,
                        changeOriginMsgMapRef,
                        originMsgMapRef,
                        currentSessionMapIdRef,
                        deerFlowHook,
                        skillListRef
                    }).catch((e) => {
                        console.error('🔥 DeerFlow一次性状态检查失败:', e);
                    });
                }, 1000); // 延迟1秒执行，确保UI已经渲染完成
            }
        }
    };

    // 组件卸载时清理所有轮询
    useEffect(() => {
        return () => {
            deerFlowHook.clearAllPollingTimers();
        };
    }, []);
    //查询后端的某个会话消息记录
    const handleGetSessionMessage = async (session, sessionSkill) => {
        let skill =
            sessionSkill ||
            skillListRef.current.find((item) => {
                return String(item.ability_id) === String(session?.skill_id);
            });

        setCurSkill(skill);

        if (isChatBIype(skill?.ability_id)) {
            if (chatBIRef.current && typeof chatBIRef.current.updateHistoryMsg === 'function') {
                if (session.session_id) {
                    chatBIRef.current.updateHistoryMsg(1, String(session.session_id));
                }
            }
            return false;
        }
        setRecordLoading(true);
        let res;
        let isBasic = isFileChatType(session?.skill_id);
        const shouldUseMultimodalHistory = isMultimodalHistorySkill(session?.skill_id, isMultimodalLearningType);

        if (shouldUseMultimodalHistory) {
            const handledMultimodalHistory = await handleMultimodalHistoryWithUI(session, {
                handelSessionHistoryMessage
            });
            if (handledMultimodalHistory) {
                setRecordLoading(false);
                return;
            }
        }
        // 🔥 第一步：先尝试获取通用历史记录，检查handler类型
        const preliminaryRes = await handleHistoryRecord({ session_id: session.session_id }, isBasic).catch((err) => {
            console.error('🔥 获取历史记录失败:', err);
            return null;
        });

        // 🔥 第二步：根据历史消息的实际handler类型或content_type，选择对应的处理函数
        if (preliminaryRes && preliminaryRes.success && preliminaryRes.data && preliminaryRes.data.length > 0) {
            const firstMessage = preliminaryRes.data[0];
            const actualHandler = firstMessage.handler;
            const contentType = firstMessage.content_type;

            // 🔥 关键修复：检查是否包含AIPPT类型的消息（即使handler不是aippt）
            // 通过检查content_type字段来判断（aippt_catalog, aippt_cover, aippt_result, aippt_theme）
            const hasAipptContent = preliminaryRes.data.some((msg) => msg.content_type && msg.content_type.startsWith('aippt_'));

            // 🔥 根据实际的handler或content_type分发到对应的处理函数
            if (actualHandler === 'deerflow') {
                // DeerFlow 消息 - 使用 DeerFlow 专用处理
                res = await deerFlowHook
                    .handleDeerFlowHistoryWithUI(session, {
                        checkIsLogin,
                        formatHistoryRecord,
                        changeSessionMapItem,
                        changeOriginMsgMapRef,
                        originMsgMapRef,
                        startHistoryPolling: deerFlowHook.startHistoryPolling,
                        formatSessionList,
                        linkToSession,
                        currentSessionMapIdRef,
                        skillListRef
                    })
                    .finally(() => {
                        setRecordLoading(false);
                    });

                if (res) {
                    // DeerFlow历史记录已经在hook中处理完成
                    return;
                }
            } else if (actualHandler === 'aippt' || hasAipptContent) {
                // 🔥 关键修复：AIPPT 消息 - 使用 AIPPT 专用处理
                // 不仅检查 handler === 'aippt'，还检查 content_type 是否包含 aippt_*
                // 这样即使在通用技能下生成的AIPPT内容，也能正确渲染
                await aipptHook.handleAIPPTHistoryMessage(preliminaryRes.data, session);
                setRecordLoading(false);
            } else {
                // 通用消息 - 使用通用处理
                await handelSessionHistoryMessage(preliminaryRes.data, session);
                setRecordLoading(false);
            }
        } else {
            if (isDeerFlowType(session.skill_id)) {
                res = await deerFlowHook
                    .handleDeerFlowHistoryWithUI(session, {
                        checkIsLogin,
                        formatHistoryRecord,
                        changeSessionMapItem,
                        changeOriginMsgMapRef,
                        originMsgMapRef,
                        startHistoryPolling: deerFlowHook.startHistoryPolling,
                        formatSessionList,
                        linkToSession,
                        currentSessionMapIdRef,
                        skillListRef
                    })
                    .finally(() => {
                        setRecordLoading(false);
                    });

                if (res) {
                    return;
                }
            } else {
                setRecordLoading(false);
                console.error('🔥 handleGetSessionMessage - API响应失败或无数据:', preliminaryRes);
            }
        }
    };

    // 🔥 新增：将handleGetSessionMessage暴露到全局，供AIPPT组件调用
    React.useEffect(() => {
        window.handleGetSessionMessage = handleGetSessionMessage;
        return () => {
            delete window.handleGetSessionMessage;
        };
    }, [handleGetSessionMessage]);

    //获取技能列表--处理成隔离及未隔离分组
    const getGroupSkillList = (scene_setting, scene_id, toolList = [], isLogin = false) => {
        let res = getSkillList(scene_setting, scene_id, isLogin);
        let urlSkillId = searchParams.get('skill_id');

        skillListRef.current = res;
        let { apartList = [], unApartList = [] } = handleSkillGroup(res, toolList, side);
        // 默认使用后端返回的第一个技能（通用技能）
        let nextCurSkill = null;
        // 如果有隔离技能列表，优先使用第一个隔离技能
        if (apartList.length > 0) {
            nextCurSkill = apartList[0];
        }
        // 如果URL中指定了技能ID，使用该技能
        if (urlSkillId) {
            let urlSkillInfo = res.find((item) => item && item.ability_id === urlSkillId);
            if (urlSkillInfo) {
                nextCurSkill = urlSkillInfo;
            }
        }
        if (nextCurSkill) {
            setCurSkill(nextCurSkill);
        }
        setSkillList({
            apartList,
            unApartList
        });
    };
    const goHome = () => {
        let homeUrl = `${window.location.origin}/agent/${side}/o/${agentId}/chat`;
        window.location.href = homeUrl;
    };
    const handleOutLogin = async () => {
        let res = await outLogin();
        if (res && res.success) {
            Storage.remove('userInfo');
            goHome();
            return false;
        }
    };

    // 🔥 关闭多模态抽屉并重置相关状态（切换会话/菜单时使用）
    // clearReference=true 时清空引用（如切换会话/菜单）；发送消息时可传 false 保留引用
    const closeMultimodalPanel = (clearReference = true) => {
        if (setDetailPanelOpen) {
            setDetailPanelOpen(false);
        }
        if (setActiveDetailMessageId) {
            setActiveDetailMessageId(null);
        }
        if (clearReference && setMultimodalReference) {
            setMultimodalReference(null);
        }
        try {
            removeMultimodalModal('multimodal-detail-drawer');
        } catch (e) {
            // 忽略移除失败
        }
    };

    // 切换修改计划模式 - 使用hook中的方法
    const toggleEditPlanMode = () => {
        deerFlowHook.toggleEditPlanMode(setContent);
    };

    // 重置所有研究计划的编辑状态 - 使用hook中的方法
    const resetEditPlanMode = () => {
        deerFlowHook.resetEditPlanMode();
    };

    // 停止DeerFlow聊天 - 使用hook中的方法
    const stopDeerFlow = (activeReportId = null) => {
        deerFlowHook.stopDeerFlow(activeReportId, {
            currentSessionMapIdRef,
            originMsgMapRef,
            changeSessionMapItem,
            changeOriginMsgMapRef
        });
    };

    // 🔥 新增：监听会话loading状态更新事件
    useEffect(() => {
        const handleSessionLoadingUpdate = (event) => {
            const { sessionId: eventSessionId, loading: newLoading, answering: newAnswering } = event.detail;

            const currentSession = currentSessionMapIdList.current;

            // 只处理当前会话的状态更新
            if (eventSessionId === currentSession?.session_id) {
                setLoading(newLoading);

                // 同时更新sessionMap中的状态
                if (sessionMapRef.current[eventSessionId]) {
                    changeSessionMapItem(eventSessionId, {
                        ...sessionMapRef.current[eventSessionId],
                        loading: newLoading
                    });
                }
            }
        };

        window.addEventListener('session-loading-update', handleSessionLoadingUpdate);

        return () => {
            window.removeEventListener('session-loading-update', handleSessionLoadingUpdate);
        };
    }, [currentSessionMapIdList.current?.session_id]); // 依赖当前会话ID
    // const { ttsMessagesRef, ttsContentRef, TTSNewMsg, TTSNewlist, resetVoiceCallStatus, resetMessageIdState, handleTTSMessageUpdate, isInVoiceCall } =
    //     useTTSHandler({
    //         currentSessionMapIdRef,
    //         originMsgMapRef,
    //         handleMessages,
    //         changeSessionMapItem,
    //         sessionListRef,
    //         formatSessionList,
    //         isNewSessionRef,
    //         setHideTTSActions,
    //         isInAnswerRef,
    //         agentId,
    //         sessionMapRef,
    //         setSessionMap
    //     });
    return {
        handleOutLogin,
        content,
        setContent,
        loading,
        setLoading,
        isCanSendMsg,
        handleChat,
        agent,
        changeSession,
        curPlugin,
        setCurPlugin,
        handleMessages,
        createRequest,
        handelSessionHistoryMessage,
        beforeSubmitMsg,
        onSubmitMsg,
        checkIsLogin,
        curSkill,
        setCurSkill,
        choseApartSkill,
        skillListRef,
        skillList,
        setSkillList,
        formatHistoryRecord,
        resetSession,
        getSessionList,
        startNewMsg,
        sessionMap,
        setSessionMap,
        getGroupSkillList,
        handleGetSessionMessage,
        sessionList,
        sessionListRef,
        setSessionList,
        isInAnswerRef,
        recordLoading,
        setRecordLoading,
        changeTool,
        skillPreQuestion,
        setSkillPrequesion,
        clickGuide,
        goLogin,
        editPlanMode: deerFlowHook.editPlanMode,
        setEditPlanMode: deerFlowHook.setEditPlanMode,
        toggleEditPlanMode,
        resetEditPlanMode,
        planButtonsDisabled: deerFlowHook.planButtonsDisabled,
        setPlanButtonsDisabled: deerFlowHook.setPlanButtonsDisabled,
        stopDeerFlow, // 添加stopDeerFlow函数
        stopHistoryPolling: deerFlowHook.stopHistoryPolling, // 添加stopHistoryPolling函数
        originMsgMapRef, // 添加originMsgMapRef到返回值中
        currentSessionMapIdRef,
        currentSessionMapIdList, //当前历史会话全部内容
        linkToSession,
        formatSessionList,
        userid,
        changeSessionMapItem, // 🔥 添加changeSessionMapItem到返回值
        // handleTTSMessageUpdate,
        getuuid,
        isNewSessionRef,
        agentId,
        curSkillRef,
        // ttsMessagesRef,
        // ttsContentRef,
        isTargetSkillType,
        agentFile,
        setAgentFile,
        agentFileRef,
        // AIPPT 相关方法
        aipptHook,
        // TTSNewMsg,
        checkCanUse,
        isSkillNeedLogin,
        // TTSNewlist,
        // resetVoiceCallStatus,
        // resetMessageIdState, // 🔥 新增：导出重置消息ID状态的函数
        // hideTTSActions,
        setHideTTSActions,
        isFileChatType,
        isMultimodalLearningType,
        references,
        setReferences,
        referencesRef,
        multimodalReference,
        setMultimodalReference,
        multimodalReferenceRef,
        handlePaste,
        authTest,
        skillListRef, // 🔥 添加 skillListRef 用于在 WebSender 中查找通用技能
        isCaseSimulationType
    };
};

export default useChat;
